export const BASE_URL = 'https://api.modernacasa.es/api/v1';
// export const BASE_URL = 'https://devapi.modernacasa.es/api/v1';


